var ALERT_TYPE;
(function (ALERT_TYPE) {
  ALERT_TYPE["VIDEO_LOADING_ALERT"] = "VideoLoadingAlert";
  ALERT_TYPE["VIDEO_SIZE_ALERT"] = "VideoSizeAlert";
  ALERT_TYPE["FILE_SIZE_ALERT"] = "FileSizeAlert";
})(ALERT_TYPE || (ALERT_TYPE = {}));

export { ALERT_TYPE };
